import { FunctionComponent, ReactNode } from 'react'
import ResponsiveImageV2 from '@components/ResponsiveImageV2'
import { ImageRatios, ImageWidths } from '@components/ResponsiveImageV2/types'
import { TeaserMiddleToiAPIProps } from '@widgets/TeaserMiddleToi'

export type ImageProps = TeaserMiddleToiAPIProps['image'] & {
  children?: ReactNode
  className?: string
}

const RATIOS = {
  desktop: '1_1',
  tablet: '16_9',
  mobile: '16_9',
} as const satisfies ImageRatios

export const WIDTHS = {
  desktop: 632,
  tablet: 632,
  mobile: 'viewport-width',
} as const satisfies ImageWidths

const Image: FunctionComponent<ImageProps> = ({
  src,
  alt,
  crops,
  className,
  children,
}) => {
  return (
    <ResponsiveImageV2
      src={src}
      alt={alt}
      crops={crops}
      ratios={RATIOS}
      widths={WIDTHS}
      className={className}>
      {children}
    </ResponsiveImageV2>
  )
}

export default Image
